import _ from 'lodash';

$(document).on('ready turbolinks:load', () => {
  $('a.sortable[data-sort-offline]').each((index, a) => {
    const $a = $(a);
    const $table = $($a.data('sort-target'));
    if (!$table.length) {
      return;
    }

    $a.off('click').click((e) => {
      e.preventDefault();
      const rows = $table.find('tbody tr');
      const child = $a.data('sort-child');
      const desc = $a.hasClass('sort-asc');
      const sortedAsc = _(rows).sortBy(row => _.get(row, `children[${child}].innerText`));
      $table.find('tbody').empty().append(
        (desc ? sortedAsc.reverse() : sortedAsc).value(),
      );
      $a.removeClass('sort-desc sort-asc').addClass(desc ? 'sort-desc' : 'sort-asc');
    });
  });
});
